var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6841_27680)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4522 3.65625L12.4528 3.65625L12.6682 3.65625L12.6745 3.6563C13.6351 3.67006 14.5836 3.87291 15.4659 4.25324C16.3481 4.63357 17.1468 5.18394 17.8163 5.87294C18.4858 6.56193 19.0131 7.37605 19.3679 8.26881C19.7228 9.16157 19.8984 10.1155 19.8846 11.0761C19.8709 12.0367 19.668 12.9852 19.2877 13.8674C18.9074 14.7497 18.357 15.5483 17.668 16.2178C16.979 16.8874 16.1649 17.4146 15.2721 17.7695C14.3794 18.1244 13.4254 18.3 12.4648 18.2862C12.2219 18.2827 12.0277 18.0829 12.0312 17.8399C12.0347 17.597 12.2345 17.4028 12.4774 17.4063C13.3225 17.4184 14.1617 17.264 14.9471 16.9518C15.7324 16.6396 16.4486 16.1757 17.0547 15.5867C17.6608 14.9978 18.145 14.2952 18.4796 13.519C18.8142 12.7429 18.9926 11.9085 19.0047 11.0635C19.0168 10.2184 18.8624 9.37925 18.5502 8.59388C18.238 7.80851 17.7741 7.09232 17.1852 6.48621C16.5962 5.88009 15.8936 5.39592 15.1175 5.06134C14.3423 4.72717 13.509 4.54875 12.665 4.53625H12.4531C10.748 4.5386 9.11358 5.21757 7.90871 6.42405C6.70376 7.6306 6.02697 9.26607 6.02697 10.9713V14.1063C6.02697 14.3493 5.82998 14.5463 5.58697 14.5463C5.34397 14.5463 5.14697 14.3493 5.14697 14.1063V10.9713C5.14697 9.03288 5.91632 7.17376 7.28604 5.80221C8.65576 4.43066 10.5139 3.65884 12.4522 3.65625Z",
    fill: "#007C92",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19086 10.6491C9.35907 10.8245 9.35327 11.103 9.1779 11.2712L5.89165 14.4234C5.71973 14.5883 5.44778 14.5864 5.27814 14.4192L2.08127 11.267C1.90823 11.0964 1.90627 10.8178 2.07689 10.6447C2.2475 10.4717 2.52609 10.4697 2.69912 10.6404L5.5913 13.4921L8.56874 10.6361C8.74411 10.4679 9.02264 10.4737 9.19086 10.6491Z",
    fill: "#08081B",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6841_27680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/Application.6b60c7cfec6666f51016d7a294bc8a65.svg";
export { ForwardRef as ReactComponent };